import React from "react";
import { Row, Col, Card, Image, Button } from "react-bootstrap";
import { VscDeviceMobile, VscWatch } from "react-icons/vsc";
import { MdOutlineLaptopMac } from "react-icons/md";
import { VscClose } from "react-icons/vsc";
import { CgModem } from "react-icons/cg";

class _renderDevice extends React.Component {

    renderIconCatg(catg) {
        switch (catg) {
            case "Modem":
                return <CgModem className="fs-20" />
            case "Hodinky":
                return <VscWatch className="fs-20" />
            case "Notebook":
                return <MdOutlineLaptopMac className="fs-20" />
            default:
                return <VscDeviceMobile className="fs-20" />
        }
    }

    render() {
        const { e, idx } = this.props;
        return (<Row className="mb-2 h-100p" >
            <Col className="h-100p">
                <Card bg="uni" className="h-100p">
                    <Row className="mt-3 mb-3">
                        <Col className="align-items-center">
                            <Row>
                                <Col xs={2} className="d-flex justify-content-center align-items-center">
                                    {this.renderIconCatg(e.catg)}
                                </Col>
                                <Col xs={10}>
                                    <Col xs={12} className="d-flex justify-content-end">
                                        <Button size="sm" variant="light" data-tip="Smazat" onClick={this.props.deleteItm}><VscClose /></Button>
                                    </Col>
                                    <Col xs={12}>
                                        <span><strong>{e.devname}</strong></span>
                                    </Col>
                                    <Col xs={12}>
                                        <small>{e.shopName}</small>
                                    </Col>
                                    <Col xs={12}>
                                        <small>{e.mdlgrp}</small>
                                    </Col>
                                    <Col xs={12}>
                                        <small>{e.catg}</small>
                                    </Col>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>)
    }
}

export default _renderDevice